// direct_lab_checkout.* funnel events (BUT-1116). Values must match the
// taxonomy enums in
// apps/analytics/services/analytics/mixpanel/taxonomy/direct_lab_checkout/base_struct.rb
// (BUT-1115) — the FE payload key/value pairs are validated server-side
// against that Dry::Struct schema.
type DirectLabCheckoutItemType = "test" | "panel";

type DirectLabCheckoutSource = "storefront_link" | "product_link" | "email" | "other";

const isDirectLabCheckoutItemType = (value: unknown): value is DirectLabCheckoutItemType =>
  value === "test" || value === "panel";

interface DirectLabCheckoutAnalyticsContext {
  checkout_source: DirectLabCheckoutSource;
  item_id: string;
  item_type: DirectLabCheckoutItemType;
  session_id: string;
  store_id: string;
  store_slug: string;
}

type DirectLabCheckoutRouteContext = Pick<
  DirectLabCheckoutAnalyticsContext,
  "item_id" | "item_type" | "store_slug"
>;

export type {
  DirectLabCheckoutAnalyticsContext,
  DirectLabCheckoutItemType,
  DirectLabCheckoutRouteContext,
  DirectLabCheckoutSource,
};
export { isDirectLabCheckoutItemType };
